// extracted by mini-css-extract-plugin
module.exports = {"rectButton":"RectangularButton_rectButton__3efaH"};